import script from "./DetailForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailForm.vue?vue&type=script&setup=true&lang=ts"

import "./DetailForm.vue?vue&type=style&index=0&id=60b01b2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b01b2c"]])

export default __exports__